export default "__VITE_ASSET__B7NuDIp6__"